// export const apiBaseUrl = "http://localhost:3200/";
// export const baseUrl = "http://localhost:3000/";

// export const apiBaseUrl = "http://52.207.216.184:4040/";
// export const baseUrl = "http://52.207.216.184:98/";

export const apiBaseUrl = "https://api.mountainsafetycollective.org/";
export const baseUrl = "https://reports.mountainsafetycollective.org/";
 